<template>
  <div
    v-loading.fullscreen="loading"
    class="app-main-content"
    element-loading-text="Loading..."
    element-loading-spinner="el-icon-loading"
  >
    <div class="tabs-container">
      <el-tabs v-model="activeTabName" type="card" style="width:100%;height: 100%">
        <el-tab-pane :lazy="true" :label="$t('CargoMsg.Cargo_BankReceiptRecord')" name="bankSlipRegister" style="width:100%;height: 100%">
          <bank-slip-register
            tab-name="bankSlipRegister"
            :tab-title="$t('CargoMsg.Cargo_BankReceiptRecord')"
          />
        </el-tab-pane>
        <el-tab-pane :lazy="true" :label="$t('CargoMsg.Cargo_ClaimBankReceipt')" name="bankSlipRollBack" style="width:100%;height: 100%">
          <bank-slip-write-off
            tab-name="bankSlipWriteOff"
            :tab-title="$t('CargoMsg.Cargo_ClaimBankReceipt')"
          />
        </el-tab-pane>
        <el-tab-pane :lazy="true" :label="$t('CargoMsg.Cargo_RevokeClaim')" name="bankSlipWriteOff" style="width:100%;height: 100%">
          <bank-slip-roll-back
            tab-name="bankSlipRollBack"
            :tab-title="$t('CargoMsg.Cargo_RevokeClaim')"
          />
        </el-tab-pane>
      </el-tabs>
    </div>
  </div>
</template>

<script>
import bankSlipRegister from '@/views/cargo/v0/Clearing/components/bankSlip/bankSlipRegister'
import bankSlipWriteOff from '@/views/cargo/v0/Clearing/components/bankSlip/bankSlipWriteOff'
import bankSlipRollBack from '@/views/cargo/v0/Clearing/components/bankSlip/bankSlipRollBack'

export default {
  name: 'FmBankSlip',
  components: { bankSlipRegister, bankSlipWriteOff, bankSlipRollBack },
  data() {
    return {
      loading: true,
      activeTabName: 'bankSlipRegister'
    }
  },
  async created() {
    this.loading = false
  }
}
</script>
